import debug from 'src/debug';
import {get, find, unset, last, toPath, set} from 'lodash';
import moment from 'moment';
import schema from './appointment_db';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import * as Subprofile from './subprofile';
import * as Transaction from './transaction';
import {DatePicker} from 'element-ui';

export function title(model) {
  let p = get(model, 'subprofile');
  p = p ? Subprofile.title.call(this, p, Subprofile) : null;
  return p || i18n.s('schema.appointment');
}

export const columns = utils.columnsFn(schema);

export const list = utils.listFn('getAppointments_byAdmin', function (payload) {
  if (get(this, 'schemaParams.created_at')) {
    payload.created_at = {
      $gte: +moment(this.schemaParams.created_at).startOf('month'),
      $lte: +moment(this.schemaParams.created_at).endOf('month'),
    };
  }
  return payload;
});
export const view = utils.viewFn('/admin/appointments/:id');
export const read = utils.readFn('getAppointmentById', 'appointment_id', null, null, function (p) {
  return p.then(response => {
    if (!response.body) {
      throw new Error(i18n.f('alert.empty_response', {response}));
    }
    let result = response.body;
    if (!result.success) {
      console.error(response);
      return Promise.reject(result.err.hk || result.err);
    }
    if (!result.data) {
      console.error(response);
      throw new Error(i18n.f('alert.invalid_response', {response}));
    }
    for (let x of get(result.data, 'potential_recipients', [])) {
      unset(x, 'recipient.details.profile.service_location');
      unset(x, 'recipient.details.profile.emergency_contact');
    }
    unset(result, 'data.sender.details.profile.service_location');
    unset(result, 'data.sender.details.profile.emergency_contact');
    return result.data;
  });
});
// export const create = utils.createFn('/admin/appointments/create');

export {edit};

export function tableFilters(schema) {
  if (this.schemaParams) {
    this.schemaParams.created_at = null;
    return [
      h => h(DatePicker.name, {
        props: {
          value: this.schemaParams.created_at,
          type: 'month',
          placeholder: i18n.fr('label_pick_a_month'),
        },
        on: {
          input: v => {
            this.schemaParams.created_at = v;
            this.queryChanged();
          },
        },
      }),
    ];
  }
  return [];
}

export function formActions(model, schema, readonly) {
  let temp = [];

  let invoice = last(get(model, 'details.invoices', []));
  if (invoice) {
    temp.push({
      label: i18n.fr('action.view_invoice'),
      class: 'btn-info',
      action(model) {
        let invoice = last(get(model, 'details.invoices', []));
        return utils.viewFn('/admin/transactions/:id').call(
          this,
          invoice,
          0,
          Transaction,
          Transaction.columns.call(this, invoice, Transaction, false, false),
        );
      },
    });
  }

  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      action: utils.updateFn('updateAppointmentById', 'appointment_id', [
        'status',
        'details.remarks',
        'details.service_date',
        'details.ticket_required',
        'progress_status',
        'potential_recipients',
        'invoice_completed',
      ]),
    });
    if (debug.DEBUG) {
      temp.push({
        label: i18n.s('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: e => e.keyCode === 46,
        action: utils.formActions.delete('deleteAppointmentById', 'appointment_id', '/admin/appointments'),
      });
    }
  }
  let status = get(model, 'progress_status');
  let caregiver = find(get(model, 'potential_recipients', []), x => [
    'confirmed',
    'arrived',
    'absent',
    'late',
    'reported',
    'feedbacked',
    'invoice_sent',
    'complete',
  ].indexOf(x.status) >= 0);
  let helper_status = get(caregiver, 'status');
  if (status == 'waiting_admin_approve') {
    temp.push({
      label: i18n.s('action.approve'),
      class: 'btn-success',
      action: utils.updateFn('approveAppointment', 'appointment_id', []),
    });
  } else if (['waiting_helper_confirm', 'waiting_admin_confirm', 'matching_helper'].indexOf(status) >= 0) {
    temp.push({
      label: i18n.s('action.distribute_job'),
      class: 'btn-info',
      action: utils.updateFn('redistributeJob', 'appointment_id', []),
    });
  }
  if (helper_status == 'invoice_sent' && 'complete' !== status) {
    temp.push({
      label: i18n.fr('action.complete_appointment'),
      class: 'btn-success',
      action: utils.updateFn('completeAppointment', 'appointment_id', []),
    });
  }
  if ('complete' === status) {
    if (caregiver) {
      temp.push({
        label: i18n.fr('action.send_feedback_to_caregiver'),
        class: 'btn-success',
        action(model, schema, columns) {
          this.$router.push(`/admin/feedback-admin/create?type=admin_to_caregiver&member_id=${caregiver.recipient.member_id}&appointment_id=${model.appointment_id}`);
          return Promise.resolve(false);
        },
      });
    }
    temp.push({
      label: i18n.fr('action.send_feedback_to_client'),
      class: 'btn-success',
      action(model, schema, columns) {
        if (model.sender) {
          this.$router.push(`/admin/feedback-admin/create?type=admin_to_client&member_id=${model.sender.member_id}&appointment_id=${model.appointment_id}`);
        }
        return Promise.resolve(false);
      },
    });
  }

  temp.push(utils.formActions.back);
  return temp;
}

export function listActions(schema, readonly) {
  let temp = [];
  temp.push({
    label: i18n.fr('action.export_data'),
    action: utils.exportFn({
      'details.order.order_id': 'Order ID',
      'appointment_id': 'Booking ID',
      'created_at': 'Created At',
      'status': 'Status',

      'sender.details.profile.first_name': 'Client - First Name',
      'sender.details.profile.last_name': 'Client - Last Name',
      'sender.details.profile.other_name': 'Client - Other Name',
      'sender.details.profile.gender': 'Client - Gender',
      'sender.verification.email.value': 'Client - Email',
      'sender.verification.phone.value': 'Client - Mobile no.',
      'sender.basic_info_fulfilled': 'Client - Basic info fulfilled',
      'sender.email_fulfilled': 'Client - Email fulfilled',
      'sender.app_config.notification.sms': 'Client - User Preference - SMS',
      'sender.app_config.notification.email': 'Client - User Preference - Email',
      'sender.app_config.notification.promotion': 'Client - Receive Promotion',
      'sender.app_config.language': 'Client - Language',

      'subprofile.subprofile_id': 'Service User - ID',
      'subprofile.details.profile.first_name': 'Service User - First Name',
      'subprofile.details.profile.last_name': 'Service User - Last Name',
      'subprofile.details.profile.gender': 'Service User - Gender',
      'subprofile.details.profile.birthday': 'Service User - Date of Birth',
      'subprofile.details.medical_history.disease.cancer': 'Service User - Cancer',
      'subprofile.details.medical_history.disease.stroke': 'Service User - Stroke',
      'subprofile.details.medical_history.disease.genetic_disease': 'Service User - Genetic Disease',
      'subprofile.details.medical_history.disease.heart_disease': 'Service User - Heart Disease',
      'subprofile.details.medical_history.disease.hypertension': 'Service User - Hypertension',
      'subprofile.details.medical_history.disease.diabetes': 'Service User - Diabetes',
      'subprofile.details.medical_history.otherDisease': 'Service User - Other Disease',
      'subprofile.details.medical_history.doneSurgery': 'Service User - Done Surgery',
      'subprofile.details.medical_history.surgery': 'Service User - Surgery',
      'subprofile.details.medical_history.mentalTreatment': 'Service User - Mental Treatment',
      'subprofile.details.medical_history.useService': 'Service User - Use Service',

      'progress_status': 'Progress Status',
      'caregiver.status': 'Caregiver Status',
      'caregiver.name': 'Caregiver Name',
      'potential_recipients.length': '# of Caregiver',
      'details.order.product.details.title.en': 'Product',
      'details.service_date': 'Service Date',

      'details.order.service_location.area': 'Service Location - Area',
      'details.order.service_location.district': 'Service Location - District',
      'details.order.service_location.address': 'Service Location - Address',

    }, async function (row, fields) {

      row.caregiver = row.potential_recipients.find(x => [
        'accepted',
        'confirmed',
        'arrived',
        'absent',
        'late',
        'reported',
        'feedbacked',
        'invoice_sent',
        'complete',
      ].includes(x.status));

      let disease = get(row, 'subprofile.details.medical_history.disease');
      if (disease) {
        for (let key of disease) {
          disease[key] = true;
        }
      }

      if (row.caregiver) {
        row.caregiver.name =
          get(row, 'caregiver.recipient.details.profile.last_name', '') + ' '
          + get(row, 'caregiver.recipient.details.profile.first_name', '');
      }

      let filter = x => {
        for (let k in fields) {
          k = toPath(k);
          if (get(x, k) == null) {
            set(x, k, '');
          }
        }
      };

      filter(row);
      return row;
    }),
  });
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/appointment.js